import * as angular from "angular";
import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";
import {DataStoreConfig} from "../persistence-layer/models/datastore-config.model";

angular
  .module('bringoz.admin.order-planning-configuration')
  .factory('$orderPlanningConfiguration', OrderPlanningConfigurationObjectFactory);

/* @ngInject */
function OrderPlanningConfigurationObjectFactory($bringozFactory: $bringozFactory,
                                                 OrdersPlanningConfigurationAPI: BringozApi,
                                                 Custom_Order_Planning_Configuration_DS: DataStoreConfig
) {

  function $orderPlanningConfiguration(id: string) {
    return $bringozFactory(id, OrdersPlanningConfigurationAPI, Custom_Order_Planning_Configuration_DS);
  }

  return $orderPlanningConfiguration;
}
